import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { ContractTypeSelector } from '../atomic-components/ContractTypeSelector';
import { ContractStartDatePicker } from '../atomic-components/ContractStartDatePicker';
import { ContractEndDatePicker } from '../atomic-components/ContractEndDatePicker';
import { AssetOccupancy } from '../addedit-forms/Occupancy';
import { MonthlyDistributionDateSelector } from '../atomic-components/MonthlyDistributionDateSelector';
import { RentalIncomeField } from '../atomic-components/RentalIncomeField';
import { RentalSurplus } from '../addedit-forms/RentalSurplus';
import { PlannedFirstRentalIncomeDatePicker } from '../atomic-components/PlannedFirstRentalIncomeDatePicker';
import { PayoutIntervalSelector } from '../atomic-components/PayoutIntervalSelector';
import React from 'react';

export const AssetApprovalRentalDetails = () => {
  return (
    <LaunchpadCard title={'Rental Details'}>
      <ContractTypeSelector />
      <ContractStartDatePicker />
      <ContractEndDatePicker />
      <AssetOccupancy />
      <PayoutIntervalSelector />
      <MonthlyDistributionDateSelector />
      <RentalIncomeField />
      <RentalSurplus />
      <PlannedFirstRentalIncomeDatePicker />
    </LaunchpadCard>
  );
};
